/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Col, Row, Typography } from 'antd';
import { useState } from 'react';
import { Button } from '@/components/button';
import { PlusOutlined } from '@ant-design/icons';
import ProductManagementTable from '@/components/tables/product-management/product-management.table';
import ProductByListTable from '@/components/tables/product-management/product-by-list.table';
import { PageURLs } from '@/utils/navigate';
import { useQuery } from '@/hooks/query.hook';
import { PermissionMode } from '@/enums/mode.enum';

export default function ProductManagement() {
    const [activeTab, setActiveTab] = useState('TABLE');
    const { push } = useQuery();
    
    const onAdd = () => {
      push(`${PageURLs.ofProductManagement()}?mode=${PermissionMode.CREATE}`);
    }
    return (
        <div css={rootStyles}>
            {!['IMPORT', 'IMPORT_BY_LIST'].includes(activeTab) && (
                <>
                    <Row css={boxStyles} justify="space-between" align="middle">
                        <Col>
                            <Typography.Title css={titleStyles} level={5}>
                                Quản lý sản phẩm AVN
                            </Typography.Title>
                        </Col>
                        <Col>
                            <Row justify="space-between" css={{ gap: '10px' }}>
                                <Button
                                    icon={<PlusOutlined />}
                                    iconPosition="start"
                                    onClick={onAdd}
                                    css={selfInputButtonStyles}
                                >
                                    Tự nhập từng sản phẩm
                                </Button>
                                <Button
                                    onClick={() => setActiveTab('IMPORT_BY_LIST')}
                                    css={listInputButtonStyles}
                                >
                                    Nhập sản phẩm mới theo danh sách
                                </Button>
                            </Row>
                        </Col>
                    </Row>
                </>
            )}

            <div css={contentStyles}>
                {activeTab === 'TABLE' && <ProductManagementTable setActiveTabProps={setActiveTab}/>}
                {/* {activeTab === 'IMPORT' && <ProductManagementCreateForm setActiveTabProps={setActiveTab} />} */}
                {activeTab === 'IMPORT_BY_LIST' && <ProductByListTable setActiveTabProps={setActiveTab} />}
            </div>
        </div>
    );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const contentStyles = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const selfInputButtonStyles = css`
  color: var(--blue-light-color);
  border-color: var(--blue-light-color);

  &:hover {
    background-color: var(--white-color) !important;
    color: var(--blue-light-color) !important;
    border-color: var(--blue-light-color) !important;
  }
`;

const listInputButtonStyles = css`
  background-color: var(--success-color);
  color: var(--white-color);
  border-color: var(--success-color);

  &:hover {
    background-color: var(--success-color) !important;
    border-color: var(--success-color) !important;
  }
`;